import { environment } from './../../../environments/environment';
// import { Injectable } from '@angular/core';
// import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
// import { Observable, throwError } from 'rxjs';
// import { catchError, map } from 'rxjs/operators';
// import { SessionService } from '../session/session.service';
// import { LoginService } from '../login/login.service';
// import { LoaderService } from 'src/app/modules/loader/services/loader/loader.service';
// import { Session } from 'src/app/classes/session/session';
// import { MessageService } from '../message/message.service';
// import { LanguageService } from '../shared/language/language.service';

// @Injectable({
//   providedIn: 'root'
// })
// export class RequestInterceptorService implements HttpInterceptor {
//   session: Session;

//   loading = [];

//   private requests: HttpRequest<any>[] = [];

//   constructor(
//     private _session: SessionService,
//     private loader_svc: LoaderService,
//     private message_service: MessageService,
//     private _LanguageService: LanguageService,

//   ) {
//     this._session.getSession().subscribe(res => {
//       this.session = res;
//
//     })
//   }

//   removeRequest(req: HttpRequest<any>) {
//     //
//     // const i = this.requests.indexOf(req);
//     //
//     // if (i >= 0) {
//     //   this.requests.splice(i, 1);
//     // }
//     //
//     this.requests.splice(0, 1);
//     if (this.requests.length <= 0) {
//       this.loader_svc.loader_sub.next(false);
//     }
//     //
//   }

//   intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
//     if (request instanceof HttpRequest)
//       this.requests.push(request);

//     let token;
//
//     if (this._session && this._session.user && this._session.user.access_token) {
//       token = this._session.user.access_token;
//       request = request.clone({
//         setHeaders: {
//           Authorization: `Bearer ${token}`
//         }
//       });
//     }

//     let language = this._LanguageService.getCurrentLanguage() || {};
//     request = request.clone({
//       setParams: {
//         lngId: language.lng_id || 1,
//       }
//     })

//     return Observable.create(observer => {
//       this.loader_svc.showLoader();
//       const subscription = next.handle(request)
//         .subscribe(
//           event => {
//             //
//             if (event instanceof HttpResponse) {
//               //
//               this.message_service.storage = event.status;
//               if (event.status === 401 || event.body.code == 401) {
//                 this.message_service.storage = 401;

//                 this._session.logout();
//                 // location.reload(true);
//               }
//               this.removeRequest(request);
//               observer.next(event);
//             }
//           },
//           err => {
//             this.removeRequest(request);
//             observer.error(err);
//           });
//       // remove request from queue when cancelled
//       return () => {
//         this.removeRequest(request);
//         subscription.unsubscribe();
//       };
//     });
//   }
// }
import { NotificationService } from 'src/app/services/shared/notification/notification.service';
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoaderService } from 'src/app/modules/loader/services/loader/loader.service';
import { LanguageService } from 'src/app/services/shared/language/language.service';
import { SessionService } from '../session/session.service';
import { Session } from 'src/app/classes/session/session';
import { getIP } from 'src/app/modules/jobseeker-registration/services/registration/jobseeker-registration.service';
var crypto = require('crypto');
var forge = require('node-forge');
forge.options.usePureJavaScript = true;
const pako = require('pako');
const aKey = 'T@MiCr097124!iCR';
var algorithm = 'aes-256-cbc';
var iv = "1234567891234567";
@Injectable({
  providedIn: "root"
})
export class RequestInterceptorService {
  session: Session;

  loading = [];
  user: any;
  secretKey: any = aKey;
  private requests: HttpRequest<any>[] = [];
  request_with_mainloader: any = [];

  constructor(
    private _LanguageService: LanguageService,
    private _session: SessionService,
    private loader_svc: LoaderService,
    private notification: NotificationService
  ) {
    this.initSession();
  }

  initSession() {
    this._session.session.subscribe(res => {
      this.session = res;
      if (!this.session) {
        this.user = null
      }
    })
  }

  removeRequest(req: HttpRequest<any>) {

    // const i = this.requests.indexOf(req);

    // if (i >= 0) {
    //   this.requests.splice(i, 1);
    // }

    this.requests.splice(0, 1);
    if (req && (!req.headers.get('header_type') || req.headers.get('header_type') == '1')) {
      if (this.request_with_mainloader.length) {
        this.request_with_mainloader.splice(0, 1)
      }
    }

    try {
      let req_with_loader = this.requests.filter(data => (!data.headers.get('header_type') || data.headers.get('header_type') == '1'));
      if (req_with_loader && req_with_loader.length == 0) {
        this.loader_svc.loader_sub.next(false);
        this.loader_svc.hideLoader();
      }
    }
    catch (err) {
      console.log(err)
    }


    if (!this.request_with_mainloader.length) {
      this.loader_svc.hideLoader();
    }
    else {
      this.loader_svc.showLoader()
    }
    if (this.requests.length <= 0) {
      this.loader_svc.loader_sub.next(false);
      this.loader_svc.hideLoader();
    }

  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request instanceof HttpRequest)
      this.requests.push(request);
    let token;

    // copy the body and trim whitespace from the name property
    // const newBody = {request.body , }
    // // clone request and set its body
    // const newReq = req.clone({ body: newBody });
    let code;
    try {
      code = environment.production? localStorage.getItem('sellerShortCode'):environment.SHORTCODE
    }
    catch (err) {
      console.log(err)
    }
    let language = this._LanguageService.getCurrentLanguage() || 1;
    request = request.clone({
      setParams: {
        lngId: language.lng_id || '1',
        sellerShortCode: code
      }
    })
    if (request.body instanceof FormData) {
      // request = request.clone({
      //   body: request.body.append('sellerShortCode', code)
      // })
    } else {
      const body = {}; body['sellerShortCode'] = code;
      request = request.clone({
        body: { ...request.body, ...body }
      })
    }

    let timestamp = Date.now();
    let ipObj = getIP();
    let ip = '';
    let region = '';
    let hash = crypto.createHash('sha512')
      .update(timestamp + ip + region + aKey)
      .digest('hex')
    if (ipObj) {
      ip = ipObj['ip'];
      region = ipObj['country'] || '';

    }
    if (this.session && this.session.token) {
      token = this.session.token;
      hash = crypto.createHash('sha512')
        .update(timestamp + ip + region + token)
        .digest('hex')
      language = this._LanguageService.getCurrentLanguage() || '1';
      request = request.clone({
        setHeaders: {
          token: token.toString(),
          ip: ip ? ip.toString() : '',
          region: region ? region.toString() : '',
          hash: hash.toString(),
          'lngId': language.toString() || '1',
          timestamp: timestamp.toString()
        }
      });
      if (request.body) {
        if (request.body instanceof FormData) {
          // request = request.clone({
          //   body: this.set('T@MiCr097124!iCR', request.body)
          // })
        } else {
          if (!this.user) {
            this.user = this._session.getSessionData();
            if (this.user && this.user.secretkey) {
              this.secretKey = this.user.secretkey;
              request = request.clone({
                body: this.set(this.secretKey, request.body)
              })
            }
          }
          else {
            request = request.clone({
              body: this.set(this.secretKey, request.body)
            })
          }
        }
      }


    }
    else {
      language = this._LanguageService.getCurrentLanguage() || '1';

      try {
        sessionStorage.removeItem('resId')
      }
      catch (err) {
        console.log(err)
      }

      hash = crypto.createHash('sha512')
        .update(timestamp + ip + region + aKey)
        .digest('hex')
      request = request.clone({
        setHeaders: {
          ip: ip.toString(),
          region: region.toString(),
          hash: hash.toString(),
          'lngId': language.toString() || '1',
          timestamp: timestamp.toString()
        },
      });
      if (request.body instanceof FormData) {
        // request = request.clone({
        //   body: request.body.append('sellerShortCode', code)
        // })
      } else {
        const body = {}; body['sellerShortCode'] = code;
        request = request.clone({
          body: this.set(aKey, request.body)
        })
      }
      // request = request.clone({
      //   setParams: {
      //     token: token,
      //     lngId: language || 1,
      //   },
      // })
    }

    let header_type;
    return Observable.create(observer => {
      if (!request.headers.has('disable_loader')) {
        header_type = request.headers.get('header_type')
        if (header_type == 2) {

        }
        else {
          this.request_with_mainloader.push(1);
          console.log(this.request_with_mainloader)
          this.loader_svc.showLoader();
        }
      }


      const subscription = next.handle(request)
        .subscribe(
          event => {
            if (event instanceof HttpResponse) {
              if (event && event.body && event.body.data && typeof event.body.data == "string") {
                this.user = this._session.getSessionData();
                if (this.user && this.user.secretkey) {
                  this.secretKey = this.user.secretkey;
                  event.body.data = this.getV3(this.secretKey, event.body.data)
                }
                else {
                  try {
                    event.body.data = this.getV3(aKey, event.body.data)
                  }
                  catch (err) {
                    console.log(err)
                  }
                }
              }
              if (event) {
                console.log(event.body)
              }
              if (event && event.body && event.body.message && !event.body.status) {
                // this.notification.error(event.body.message, 'Close', 5000);
              }
              if (event.status === 401 || (event.body && event.body.code && event.body.code == 401)) {
                // auto logout if 401 response returned from api
                this._session.logout();
                // location.reload(true);
              }
              this.removeRequest(request);
              observer.next(event);
            }
          },
          err => {
            this.removeRequest(request);
            this.loader_svc.hideLoader();
            observer.error(err);
          });
      // remove request from queue when cancelled
      return () => {
        this.removeRequest(request);
        subscription.unsubscribe();
      };
    });
  }
  getV3(secretKey, data) {
    try {
      var buffer = Buffer.from(data, 'base64')
      var encPassword = secretKey;
      var password = crypto.createHash("sha256").update(encPassword).digest(); //create password with secret key
      var decipher = crypto.createDecipheriv(algorithm, password, iv);
      var dec = Buffer.concat([decipher.update(buffer), decipher.final()]);
      var decodedData = pako.ungzip(dec);
      var textDecoder = new TextDecoder();
      var dataObject = JSON.parse(textDecoder.decode(decodedData));
      return dataObject
    }
    catch (err) {
      console.log(err);
      return data;
    }

  }
  set(keys, value) {
    try {
      var textEncoder = new TextEncoder(); //similar to buffer in node js
      var iv = '1234567891234567';
      var md = forge.md.sha256.create();//create sha 256 hash
      md.update(keys);
      var key = md.digest();
      var encodedData = textEncoder.encode(JSON.stringify(value)); //stringify to json and convert to buffer
      var gzippedData = pako.gzip(encodedData); //compress
      var cipher = forge.cipher.createCipher('AES-CBC', key);//pad7 by default :)
      cipher.start({ iv: iv });
      cipher.update(forge.util.createBuffer(gzippedData));
      cipher.finish();
      var encrypted = cipher.output;
      return { data: forge.util.encode64(encrypted.data) }
    }
    catch (err) {
      console.log(err)
      return
    }

  }

  //The get method is use for decrypt the value.
  get(keys, value) {
    try {
      var textDecoder = new TextDecoder();
      var iv = '1234567891234567';

      var md = forge.md.sha256.create();
      md.update(keys);
      var key = md.digest();
      var encryptedBytes = forge.util.decode64(value);
      var decipher = forge.cipher.createDecipher('AES-CBC', key);
      decipher.start({ iv: iv });
      var length = encryptedBytes.length;
      var chunkSize = 1024 * 64;
      var index = 0;
      var decrypted = '';
      do {
        decrypted += decipher.output.getBytes();
        var buf = forge.util.createBuffer(encryptedBytes.substr(index, chunkSize));
        decipher.update(buf);
        index += chunkSize;
      } while (index < length);
      var result = decipher.finish();
      decrypted += decipher.output.getBytes();
      console.log(decrypted)
      var decodedData = pako.ungzip(decrypted);
      var dataObject = JSON.parse(textDecoder.decode(decodedData));
      console.log(dataObject);
      return dataObject
    }
    catch (err) {
      console.log(err);
      return value
    }

  }
}
